// extracted by mini-css-extract-plugin
export default {"languageLabelAndSelector":"LanguageSelector-module__languageLabelAndSelector___293FF","languageLabel":"LanguageSelector-module__languageLabel___kqoYt"};